import { Dispatch, createContext } from 'react';
import { RootStateAction } from './actions/rootStateActions';
import { defaultFeatureFlagsState } from './models/featureFlags';
import { RootState } from './models/rootState';
import { AppTheme, LIGHT_THEME, PREFERRED_THEME_LOCAL_STORAGE_KEY } from './models/theme';
import { GptTypes } from '../EnterpriseGPTApi/EnterpriseGPTApiV1Client';

export const initialRootState: RootState = {
    chats: [
        {
            id: 'DRAFT',
            userName: '',
            startedOn: new Date(),
            currentQuery: '',
            prompts: [],
            title: '',
            llm: '',
            lastUpdateOn: undefined,
            draft: true,
            gpt: {
                id: '00000000-0000-0000-0000-000000000000',
                type: GptTypes.SyGpt
            }
        },
    ],
    conversationsCursor: undefined,
    quota: {
        userQuota: undefined,
        userQuotaPercentage: undefined,
    },
    theme: (localStorage.getItem(PREFERRED_THEME_LOCAL_STORAGE_KEY) as AppTheme) || LIGHT_THEME,
    features: {
        ...defaultFeatureFlagsState,
    },    
    userPreferences: {
        featureHighlights: {},
        speechClickSend: false,
        showLanguageSelectionInPrompt: true,

    },
    gptConfigurations: [],
    survey: undefined
};

export type StoreContextType = {
    state: RootState;
    dispatch: Dispatch<RootStateAction>;
};

export const Store = createContext<StoreContextType>({
    state: initialRootState,
    dispatch: () => null,
});
